module.exports = require("./es-SV.d.ts");